import { render, staticRenderFns } from "./feature_bullet.vue?vue&type=template&id=673b4b03&scoped=true"
import script from "./feature_bullet.vue?vue&type=script&lang=js"
export * from "./feature_bullet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b4b03",
  null
  
)

export default component.exports